import { TariffCategory } from '../../shared/models/types'
import { TariffModel, TariffTableData } from '../models/tariffs-model'
import { getCurrentDynamicPrices } from './get-current-dynamic-prices'

/**
 * Util function for mapping tariff models to the tariff table data model
 * it is used on desktop and mobile screens
 */
export const getTariffTableData = (tariffs: TariffModel[]): TariffTableData[] => {
  return tariffs.map(tariff => {
    return {
      tariffId: tariff.tariffId,
      tariffName: tariff.tariffName,
      gridPrice:
        tariff.tariffCategory === TariffCategory.staticTariff
          ? tariff.staticPrices.gridPrice
          : getCurrentDynamicPrices(tariff.dynamicPrices)?.gridPrice ||
            0 /** prevent attempt to compare "undefined" with "1.23" when sorting, undefined is considered zero when sorting in this case */,
      lastUpdated: tariff.lastUpdated,
      tariffCategory: tariff.tariffCategory,
      tariffStatus: tariff.tariffStatus,
      currencyCode: tariff.currencyCode,
      startDate: tariff.startTime,
      endDate: tariff.endTime,
    }
  })
}
